import {BoxIcon, FinishIcon, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {classes} from './PointPlacemarkIcon.classes'
import {Props} from './types'

export function PointPlacemarkIcon(props: Props) {
  const {type, children} = props

  if (type === 'source') {
    return <BoxIcon className={classes.sourcePlaceMark} />
  }

  if (type === 'destination') {
    return <FinishIcon />
  }

  return (
    <Typography thickness="medium" variant="body1">
      {children}
    </Typography>
  )
}
